export class RequestSet {
  name: string;
  active?: boolean;
  classId?: number;
  
  constructor(data: any) {
    this.name = data.name;
    this.classId = data.classId;
    this.active = data.active
  }
}